module.exports = __webpack_public_path__ + "img/time-new-icon.6291124e.svg";